import { Route, Routes } from "react-router-dom";
import MunicipalityCreateScreen from "screens/App/CRM/Locations/Municipality/MunicipalityCreateScreen";
import MunicipalityDetailScreen from "screens/App/CRM/Locations/Municipality/MunicipalityDetailScreen";
import MunicipalityEditScreen from "screens/App/CRM/Locations/Municipality/MunicipalityEditScreen";
import MunicipalityListScreen from "screens/App/CRM/Locations/Municipality/MunicipalityListScreen";

import NotFoundScreen from "screens/NotFoundScreen";

const MunicipalityRoute = () => {
  return (
    <Routes>
      <Route path="create" element={<MunicipalityCreateScreen />} />
      <Route path="list" element={<MunicipalityListScreen />} />
      <Route path=":id/edit" element={<MunicipalityEditScreen />} />
      <Route path=":id/detail" element={<MunicipalityDetailScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default MunicipalityRoute;
